<template>
    <div>
        <h4 style="text-align: center">เรทประกันสังคม</h4>
        <br>
        <div class="row form-group">
            <div class="col-4 text-right">
                ประกันสังคม
                <div style="color: red; font-size: 13px">(เงินเดือนมากกว่า 15000 บาท)</div>
            </div>
            <div class="col-6">
                <input type="number" class="form-control" placeholder="เช่น 750 บาท" v-model="form.rate">
            </div>
            <div class="col-1">บาท</div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">ประกันสังคม
                <div style="color: red; font-size: 13px">(เมื่อเงินเดือนไม่ถึง 15000)</div>
            </div>
            <div class="col-6">
                <input type="number" class="form-control" placeholder="เช่น 5%" v-model="form.rate_percent">
            </div>
            <div class="col-1">%</div>
        </div>
        <div class="col text-center">
            <button type="button"
                    @click="submitData"
                    class="btn btn-success mt-2">
                บันทึก
            </button>
            &nbsp;&nbsp;
            <button
                @click="cancelData"
                type="button"
                class="btn btn-outline-secondary mt-2">
                ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "RateSocialSecurityModal",
        computed:{
            ...mapState({
                form:state=>{
                    return state.SocialSecurity.form_security;
                },
            }),
        },
        methods:{
            submitData(){
                this.$emit("submit",this.form)
            },
            cancelData(){
                this.$emit("submit",false)
            }
        },
    }
</script>

<style scoped>

</style>
